import { render, staticRenderFns } from "./cta.vue?vue&type=template&id=b8343b36&scoped=true&lang=pug&"
import script from "./cta.vue?vue&type=script&lang=js&"
export * from "./cta.vue?vue&type=script&lang=js&"
import style0 from "./cta.vue?vue&type=style&index=0&id=b8343b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8343b36",
  null
  
)

export default component.exports